import MessageObject from "api/lib/data/interfaces/MessageObject";
import moment from "moment";
import * as React from "react";
import * as md5 from "md5";
import { Comment, Icon, Popup } from "semantic-ui-react";
import { gravatarParams } from "src/utils";

// const isImage = (message: any) => {
//   return message.hasOwnProperty("image") && !message.hasOwnProperty("content");
// };

const timeFromNow = (timestamp: object) => moment(timestamp).fromNow();

// const handleShowVersionClick = (message: any, history: any) => {
//   const { analysisId, queryId, versionId } = message;
//   history.push(routes.VERSION_BY_ID(analysisId, queryId, versionId));
// };

export interface IBotSightsProps {
  message: MessageObject;
  showVersion: (versionId: string) => void;
}

const Message = ({ message, showVersion }: IBotSightsProps) => (
  <Popup
    className="message-menu"
    basic={true}
    position="top right"
    size="tiny"
    flowing={true}
    hoverable={true}
    offset={[-10, -80]}
    trigger={
      <Comment>
        <Comment.Avatar
          src={`http://gravatar.com/avatar/${md5(
            message.from
          )}${gravatarParams()}`}
        />
        <Comment.Content>
          <Comment.Metadata
            as="a"
            style={{ marginLeft: "0px", fontStyle: "italic" }}
          >
            {message.fromName}
          </Comment.Metadata>
          <Comment.Metadata>
            {timeFromNow(message.audit.createdAt)}
          </Comment.Metadata>
          {/* {isImage(message) ? (
            <Image src={message.image} className="message__image" />
          ) : ( */}
          <Comment.Text>{message.content}</Comment.Text>
          {/* )} */}
        </Comment.Content>
      </Comment>
    }
  >
    <Popup.Content>
      <Popup
        trigger={
          <Icon
            circular={true}
            link={true}
            onClick={() => showVersion(message.queryVersion)}
            name="arrow right"
          />
        }
        content="Show this version"
        hideOnScroll={true}
      />

      <Popup
        trigger={<Icon circular={true} link={true} name="copy outline" />}
        content="Copy Version Link"
        hideOnScroll={true}
      />
      <Popup
        trigger={
          <Icon circular={true} link={true} name="share square outline" />
        }
        content="Share Message"
        hideOnScroll={true}
      />

      <Icon link={true} name="ellipsis vertical" />
    </Popup.Content>
  </Popup>
);

export default Message;



// WEBPACK FOOTER //
// ./src/components/Query/Message.tsx